export default {"src":"/_next/static/media/stars_1.3eda716b.svg","height":756,"width":756,"blurWidth":0,"blurHeight":0};